import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Grid,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
  useToast,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { HiBuildingOffice } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import InfluencerInvoiceComponent from "../Table/InfluencerInvoice";
import axios from "axios";
import Invoice from "../Table/Invoice";
import InvoiceTemplate from "../Table/InvoiceTemplate";
import html2pdf from "html2pdf.js";
const InfluenceInVoiceModal = ({
  isOpen,
  onClose,
  brandForInvoice,
  DealAmountForInvoice,
  BrandRepForInvoice,
  tal_name,
  DeliverablsForInvoice,
  LinkForInvoice,
  LoctionForInvoice,
  MailForInvoice,
  InvoiceForInvoice,
  DealIdForInvoice,
  onDateprops,
  PaymentTermForInvoice,
  fetchinfluencerDealsData,
  fetchAllInfluencerDealsData,
  setActiveDealsTab,
  activeDealsTab,
  PaymentInfo,
  CreatorPayout,
}) => {
  const role =
    useSelector((state) => state.role) || localStorage.getItem("Role");
  const BASE_URL = process.env.REACT_APP_DEPLOYED_BASE_URL;
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGeneratepdf, setIsLoadingGeneratepdf] = useState(false);
  const [InvoiceNumber, setInvoiceNumber] = useState();
  const [errors, setErrors] = useState({
    companyName: "",
    companyAddress: "",
    brandRepName: "",
    brandRepEmail: "",
    creatorName: "",
    deliverables: "",
    paymentTerms: "",
    totalAmount: "",
    link: "",
    payeesName: "",
    bankName: "",
    accountNumber: "",
    routingNumber: "",
    swiftCode: "",
    paypalEmail: "",
    zelleEmail: "",
    wire: "",
    CreatorPayout,
  });

  const [formData, setFormData] = useState({
    companyName: "",
    companyAddress: "",
    brandRepName: "",
    brandRepEmail: "",
    creatorName: "",
    deliverables: "",
    paymentTerms: "",
    totalAmount: "",
    link: "",
    payeesName: "",
    bankName: "",
    accountNumber: "",
    routingNumber: "",
    swiftCode: "",
    paypalEmail: "",
    zelleEmail: "",
    InvoiceNumber: "",
    wire: "",
    CreatorPayout: "",
  });

  const getInvoiceNumber = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/generate-invoice-number/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setInvoiceNumber(response.data.invoice_number);
        const fetchedNumber = response.data.invoice_number;
        setFormData((prev) => ({
          ...prev,
          InvoiceNumber: fetchedNumber,
        }));
      }
    } catch (error) {
      console.error("Error fetching invoice number:", error.message || error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      getInvoiceNumber();
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      const creator = tal_name.replace(/-/g, " ");

      // Populate payment info fields if available
      let payeesName = "";
      let bankName = "";
      let accountNumber = "";
      let routingNumber = "";
      let swiftCode = "";
      let paypalEmail = "";
      let zelleEmail = "";
      let wire = "";

      if (PaymentInfo) {
        payeesName = PaymentInfo.payees_name || "";
        bankName = PaymentInfo.bank_name || "";
        accountNumber = PaymentInfo.account_number || "";
        routingNumber = PaymentInfo.routing_number || "";
        swiftCode = PaymentInfo.swift_code || "";
        paypalEmail = PaymentInfo.paypal_email || "";
        zelleEmail = PaymentInfo.zelle_email || "";
        wire = PaymentInfo.wires_domestic || "";
      }

      setFormData((prev) => ({
        ...prev,
        companyName: brandForInvoice || "",
        totalAmount: DealAmountForInvoice || "",
        brandRepName: BrandRepForInvoice || "",
        creatorName: creator || "",
        deliverables: DeliverablsForInvoice || "",
        link: LinkForInvoice || "",
        companyAddress: LoctionForInvoice || "",
        brandRepEmail: MailForInvoice || "",
        paymentTerms: PaymentTermForInvoice || "",
        payeesName,
        bankName,
        accountNumber,
        routingNumber,
        swiftCode,
        paypalEmail,
        zelleEmail,
        wire,
        CreatorPayout,
      }));
    }
  }, [isOpen]);

  // Function to create payment info string from the separate fields

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Validation logic
    if (!formData.companyName.trim()) {
      newErrors.companyName = "Company name is required.";
      isValid = false;
    }
    if (!formData.companyAddress.trim()) {
      newErrors.companyAddress = "Company address is required.";
      isValid = false;
    }
    if (!formData.brandRepName.trim()) {
      newErrors.brandRepName = "Brand representative's name is required.";
      isValid = false;
    }
    if (
      !formData.brandRepEmail.trim() ||
      !/\S+@\S+\.\S+/.test(formData.brandRepEmail)
    ) {
      newErrors.brandRepEmail = "A valid email is required.";
      isValid = false;
    }
    if (!formData.creatorName.trim()) {
      newErrors.creatorName = "Creator's name is required.";
      isValid = false;
    }
    if (!formData.deliverables.trim()) {
      newErrors.deliverables = "Deliverables cannot be empty.";
      isValid = false;
    }
    if (!formData.paymentTerms.trim()) {
      newErrors.paymentTerms = "Payment terms are required.";
      isValid = false;
    }
    if (role === "Influencer") {
      if (!formData.CreatorPayout || formData.CreatorPayout <= 0) {
        newErrors.CreatorPayout = "Total amount must be greater than zero...";
        isValid = false;
      }
    } else {
      if (!formData.totalAmount || formData.totalAmount <= 0) {
        newErrors.totalAmount = "Total amount must be greater than zero.";
        isValid = false;
      }
    }



    // Validate payment information fields
    if (role === "Influencer") {
      if (!formData.payeesName.trim()) {
        newErrors.payeesName = "Payee's name is required.";
        isValid = false;
      }

      if (!formData.wire.trim()) {
        newErrors.wire = "Wires details is required.";
        isValid = false;
      }

      // At least one payment method is required
      const hasPaymentMethod =
        (formData.bankName.trim() &&
          formData.accountNumber.trim() &&
          formData.routingNumber.trim()) ||
        formData.paypalEmail.trim() ||
        formData.zelleEmail.trim();

      if (!hasPaymentMethod) {
        newErrors.bankName = "At least one payment method is required.";
        isValid = false;
      }

      // Validate email formats
      if (
        formData.paypalEmail.trim() &&
        !/\S+@\S+\.\S+/.test(formData.paypalEmail)
      ) {
        newErrors.paypalEmail = "A valid PayPal email is required.";
        isValid = false;
      }

      if (
        formData.zelleEmail.trim() &&
        !/\S+@\S+\.\S+/.test(formData.zelleEmail)
      ) {
        newErrors.zelleEmail = "A valid Zelle email is required.";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const generatePDF = async (formDataInput) => {
    const loadingToast = toast({
      title: "Preparing Invoice for Print",
      description: "Please wait...",
      status: "info",
      duration: null,
      isClosable: false,
    });

    try {
      const tempContainer = document.createElement("div");
      tempContainer.style.position = "absolute";
      tempContainer.style.left = "-9999px";
      tempContainer.style.top = "-9999px";
      tempContainer.style.width = "800px";
      document.body.appendChild(tempContainer);

      const ReactDOM = await import("react-dom/client");
      const root = ReactDOM.createRoot(tempContainer);

      // Render the appropriate component
      if (role == "Influencer") {
        root.render(<InfluencerInvoiceComponent invoiceData={formData} />);
      } else {
        root.render(<InvoiceTemplate invoiceData={formData} />);
      }

      // Wait for fonts and styles to load
      await new Promise((resolve) => {
        document.fonts.ready.then(() => setTimeout(resolve, 1000));
      });

      const htmlContent = tempContainer.innerHTML;

      // Collect styles from the current document
      const styles = Array.from(document.styleSheets)
        .map((styleSheet) => {
          try {
            return [...styleSheet.cssRules]
              .map((rule) => rule.cssText)
              .join("\n");
          } catch (e) {
            return ""; // Skip cross-origin styles
          }
        })
        .join("\n");

      // Generate the filename
      const filename = `${brandForInvoice}-${tal_name}-Invoice${InvoiceNumber}.pdf`;

      // Create a hidden iframe to generate the PDF
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.left = "-9999px";
      iframe.style.top = "-9999px";
      iframe.style.width = "800px";
      iframe.style.height = "1100px"; // A4 proportions
      document.body.appendChild(iframe);

      // Write the content to the iframe
      iframe.contentDocument.write(`
      <html>
        <head>
          <title>Invoice</title>
          <style>
            @media print {
              @page {
                size: A4;
                margin: 10mm;
              }
              body {
                margin: 0;
                padding: 0;
                background: white !important;
              }
              .print-container {
                background: white !important;
                border: none;
                max-width: 100%;
              }
            }
            body {
              background: white !important;
              margin: 0;
              padding: 0;
              box-sizing: border-box;
              font-family: Arial, sans-serif;
            }
            .print-container {
              background: white !important;
              padding: 20px;
              box-sizing: border-box;
              max-width: 800px;
              margin: 0 auto;
            }
            table {
              width: 100%;
              border-collapse: collapse;
            }
            th, td {
              padding: 8px;
              text-align: left;
              border-bottom: 1px solid #ddd;
            }
            ${styles}
          </style>
        </head>
        <body>
          <div class="print-container">${htmlContent}</div>
        </body>
      </html>
    `);
      iframe.contentDocument.close();

      // Let the iframe content fully render
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // Use html2pdf.js or a similar library to convert the iframe content to PDF
      // This is a stub - you'll need to add the actual html2pdf.js code
      // Assuming you've imported the html2pdf library

      // Method 1: Use html2pdf.js if available
      const pdfBlob = await new Promise((resolve) => {
        if (typeof html2pdf !== "undefined") {
          const element = iframe.contentDocument.body;
          const opt = {
            margin: 10,
            filename: filename,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
          };

          html2pdf()
            .set(opt)
            .from(element)
            .outputPdf("blob")
            .then((blob) => resolve(blob));
        } else {
          // Method 2: Fallback to jsPDF + html2canvas if html2pdf isn't available
          import("html2canvas").then((html2canvas) => {
            html2canvas
              .default(iframe.contentDocument.body, {
                scale: 2,
                useCORS: true,
                backgroundColor: "#FFFFFF",
              })
              .then((canvas) => {
                const imgData = canvas.toDataURL("image/jpeg", 1.0);

                import("jspdf").then((jsPDF) => {
                  const pdf = new jsPDF.default("p", "mm", "a4");
                  const pageWidth = pdf.internal.pageSize.getWidth();
                  const pageHeight = pdf.internal.pageSize.getHeight();
                  const imgWidth = pageWidth;
                  const imgHeight = (canvas.height * imgWidth) / canvas.width;

                  pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
                  const blob = pdf.output("blob");
                  resolve(blob);
                });
              });
          });
        }
      });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const printWindow = window.open(pdfUrl, "_blank");
      if (!printWindow) {
        console.warn(
          "Popup blocked. PDF generated but couldn't be opened in a new window."
        );
      }

      document.body.removeChild(tempContainer);
      toast.close(loadingToast);
      toast({
        title: "Print Ready!",
        description: "Your invoice was sent to the printer.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      return true;
    } catch (error) {
      toast.close(loadingToast);
      console.error("Print error:", error);
      toast({
        title: "Print Failed",
        description: error.message || "An unknown error occurred.",
        status: "error",
        duration: 7000,
        isClosable: true,
      });
      return false;
    }
  };

  // Update the handleSubmit function to use the enhanced generatePDF
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setIsLoadingGeneratepdf(true);

      try {
        // Call the enhanced generatePDF function with the form data
        const success = await generatePDF(formData);

        if (!success) {
          throw new Error("PDF generation failed");
        }
        onClose();
      } catch (error) {
        console.error("Error:", error);
        toast({
          title: "Error",
          description: "Failed to generate invoice. Please try again.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setIsLoadingGeneratepdf(false);
        //fetchAllInfluencerDealsData()
        fetchinfluencerDealsData()
      }
    } else {
      toast({
        title: "Validation Failed",
        description: "Please correct the errors in the form.",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  // Handle form data updates
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };


  useEffect(() => {
    if (!isOpen) {
      setFormData({
        companyName: "",
        companyAddress: "",
        brandRepName: "",
        brandRepEmail: "",
        creatorName: "",
        deliverables: "",
        paymentTerms: "",
        totalAmount: "",
        link: "",
        payeesName: "",
        bankName: "",
        accountNumber: "",
        routingNumber: "",
        swiftCode: "",
        paypalEmail: "",
        zelleEmail: "",
      });
      setErrors({});
    }
  }, [isOpen]);

  const handleSend = async () => {
    if (validateForm()) {
      setIsLoading(true);
      const toastId = toast({
        title: "Preparing PDF",
        description: "Please wait while we generate and send the invoice...",
        status: "info",
        duration: null,
        isClosable: false,
      });

      try {
        // Create a hidden container for rendering the component
        const tempContainer = document.createElement("div");
        tempContainer.style.position = "absolute";
        tempContainer.style.left = "-9999px";
        tempContainer.style.top = "-9999px";
        tempContainer.style.width = "800px";
        document.body.appendChild(tempContainer);

        const ReactDOM = await import("react-dom/client");
        const root = ReactDOM.createRoot(tempContainer);

        // Render the appropriate component
        if (role == "Influencer") {
          root.render(<InfluencerInvoiceComponent invoiceData={formData} />);
        } else {
          root.render(<InvoiceTemplate invoiceData={formData} />);
        }

        // Wait for fonts and styles to load
        await new Promise((resolve) => {
          document.fonts.ready.then(() => setTimeout(resolve, 1000));
        });

        const htmlContent = tempContainer.innerHTML;

        // Collect styles from the current document
        const styles = Array.from(document.styleSheets)
          .map((styleSheet) => {
            try {
              return [...styleSheet.cssRules]
                .map((rule) => rule.cssText)
                .join("\n");
            } catch (e) {
              return ""; // Skip cross-origin styles
            }
          })
          .join("\n");

        // Generate the filename
        const filename = `${brandForInvoice}-${tal_name}-Invoice${InvoiceNumber}.pdf`;

        // Create a hidden iframe to generate the PDF
        const iframe = document.createElement("iframe");
        iframe.style.position = "absolute";
        iframe.style.left = "-9999px";
        iframe.style.top = "-9999px";
        iframe.style.width = "800px";
        iframe.style.height = "1100px"; // A4 proportions
        document.body.appendChild(iframe);

        // Write the content to the iframe
        iframe.contentDocument.write(`
        <html>
          <head>
            <title>Invoice</title>
            <style>
              body {
                background: white !important;
                margin: 0;
                padding: 0;
                box-sizing: border-box;
              }
              .print-container {
                background: white !important;
                padding: 20px;
                box-sizing: border-box;
              }
              @media print {
                body {
                  margin: 0;
                  padding: 0;
                }
                .print-container {
                  background: white !important;
                  border: none;
                }
              }
              ${styles}
            </style>
          </head>
          <body>
            <div class="print-container">${htmlContent}</div>
          </body>
        </html>
      `);
        iframe.contentDocument.close();

        // Let the iframe content fully render
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // Use html2pdf.js or a similar library to convert the iframe content to PDF
        // This is a stub - you'll need to add the actual html2pdf.js code
        // Assuming you've imported the html2pdf library

        // Method 1: Use html2pdf.js if available
        const pdfBlob = await new Promise((resolve) => {
          if (typeof html2pdf !== "undefined") {
            const element = iframe.contentDocument.body;
            const opt = {
              margin: 10,
              filename: filename,
              image: { type: "jpeg", quality: 0.98 },
              html2canvas: { scale: 2, useCORS: true },
              jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
            };

            html2pdf()
              .set(opt)
              .from(element)
              .outputPdf("blob")
              .then((blob) => resolve(blob));
          } else {
            // Method 2: Fallback to jsPDF + html2canvas if html2pdf isn't available
            import("html2canvas").then((html2canvas) => {
              html2canvas
                .default(iframe.contentDocument.body, {
                  scale: 2,
                  useCORS: true,
                  backgroundColor: "#FFFFFF",
                })
                .then((canvas) => {
                  const imgData = canvas.toDataURL("image/jpeg", 1.0);

                  import("jspdf").then((jsPDF) => {
                    const pdf = new jsPDF.default("p", "mm", "a4");
                    const pageWidth = pdf.internal.pageSize.getWidth();
                    const pageHeight = pdf.internal.pageSize.getHeight();
                    const imgWidth = pageWidth;
                    const imgHeight = (canvas.height * imgWidth) / canvas.width;

                    pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
                    const blob = pdf.output("blob");
                    resolve(blob);
                  });
                });
            });
          }
        });

        // Now create a form to send the PDF data
        const data = new FormData();
        data.append("pdf_path", pdfBlob, filename);
        data.append("company", brandForInvoice);
        data.append("brand_rep", BrandRepForInvoice);
        data.append("deal_id", DealIdForInvoice);

        const config = {
          method: "post",
          maxBodyLength: Infinity,
          url: `${BASE_URL}/send-invoice/`,
          headers: {
            Accept: "application/json, text/plain, */*",
            Authorization: `Bearer ${token}`,
          },
          data,
        };

        // Send the PDF data to the server
        const response = await axios.request(config);

        if (response.status === 200) {
          toast.close(toastId);
          toast({
            title: "Success",
            description: "Invoice Sent Successfully",
            status: "success",
            duration: 3000,
            isClosable: true,
          });

          // Also open the PDF in a new window for preview/printing
          const pdfUrl = URL.createObjectURL(pdfBlob);
          const printWindow = window.open(pdfUrl, "_blank");
          if (!printWindow) {
            console.warn(
              "Popup blocked. PDF generated but couldn't be opened in a new window."
            );
          }

          onClose();
          if (activeDealsTab) {
            setActiveDealsTab(false);
          }
        } else {
          throw new Error("Server returned error");
        }

        // Clean up
        document.body.removeChild(tempContainer);
        document.body.removeChild(iframe);
      } catch (error) {
        toast.close(toastId);
        toast({
          title: "Error",
          description: `Failed to send invoice: ${error.message || "Unknown error"
            }`,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        console.error("PDF send error:", error);
      } finally {
        setIsLoading(false);
        //fetchAllInfluencerDealsData()
        fetchinfluencerDealsData()
      }
    } else {
      toast({
        title: "Validation Failed",
        description: "Please correct the errors in the form.",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Box>
      <Modal size={"4xl"} isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent height={{ base: "30vh", md: "auto" }}>
          <ModalHeader fontWeight={"500"} fontSize={"2xl"}>
            <Flex alignItems={"center"} gap={2}>
              <HiBuildingOffice size={28} />
              Generate Invoice
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody className="companyModal_body">
            <Box bg="white" mx={4} rounded="md">
              <form className="influenceInvoiceModel">
                <Box mb={6}>
                  <Grid
                    templateColumns={{ base: "1fr", md: "1fr 1fr" }}
                    gap={6}
                  >
                    <FormControl isInvalid={!!errors.companyName}>
                      <FormLabel fontWeight="medium">Company Name</FormLabel>
                      <Input
                        name="companyName"
                        value={formData.companyName}
                        onChange={handleChange}
                        border="1px"
                        borderColor="#333"
                        _focus={{ borderColor: "blue" }}
                      />
                      {errors.companyName && (
                        <FormErrorMessage>
                          {errors.companyName}
                        </FormErrorMessage>
                      )}
                    </FormControl>

                    <FormControl isInvalid={!!errors.companyAddress}>
                      <FormLabel fontWeight="medium">Company Address</FormLabel>
                      <Input
                        name="companyAddress"
                        value={formData.companyAddress}
                        onChange={handleChange}
                        border="1px"
                        borderColor="black.300"
                        _focus={{ borderColor: "blue" }}
                      />
                      {errors.companyAddress && (
                        <FormErrorMessage>
                          {errors.companyAddress}
                        </FormErrorMessage>
                      )}
                    </FormControl>
                  </Grid>
                </Box>

                <Box mb={6}>
                  <Grid
                    templateColumns={{ base: "1fr", md: "1fr 1fr 1fr" }}
                    gap={6}
                  >
                    <FormControl isInvalid={!!errors.brandRepName}>
                      <FormLabel fontWeight="medium">
                        Brand Rep's Name
                      </FormLabel>
                      <Input
                        name="brandRepName"
                        value={formData.brandRepName}
                        onChange={handleChange}
                        border="1px"
                        borderColor="gray.300"
                        _focus={{ borderColor: "blue" }}
                      />
                      {errors.brandRepName && (
                        <FormErrorMessage>
                          {errors.brandRepName}
                        </FormErrorMessage>
                      )}
                    </FormControl>

                    <FormControl isInvalid={!!errors.brandRepEmail}>
                      <FormLabel fontWeight="medium">
                        Brand Rep's Email
                      </FormLabel>
                      <Input
                        name="brandRepEmail"
                        type="email"
                        value={formData.brandRepEmail}
                        onChange={handleChange}
                        border="1px"
                        borderColor="gray.300"
                        _focus={{ borderColor: "black" }}
                      />
                      {errors.brandRepEmail && (
                        <FormErrorMessage>
                          {errors.brandRepEmail}
                        </FormErrorMessage>
                      )}
                    </FormControl>

                    <FormControl isInvalid={!!errors.creatorName}>
                      <FormLabel fontWeight="medium">Creator's Name</FormLabel>
                      <Input
                        name="creatorName"
                        value={formData.creatorName}
                        onChange={handleChange}
                        border="1px"
                        borderColor="gray.300"
                        _focus={{ borderColor: "blue" }}
                      />
                      {errors.creatorName && (
                        <FormErrorMessage>
                          {errors.creatorName}
                        </FormErrorMessage>
                      )}
                    </FormControl>
                  </Grid>
                </Box>

                <Box mb={6}>
                  <FormControl isInvalid={!!errors.deliverables}>
                    <FormLabel fontWeight="medium">Deliverables</FormLabel>
                    <Textarea
                      name="deliverables"
                      value={formData.deliverables}
                      onChange={handleChange}
                    />
                    {errors.deliverables && (
                      <FormErrorMessage>{errors.deliverables}</FormErrorMessage>
                    )}
                  </FormControl>
                </Box>

                <Box mb={6}>
                  <Grid
                    templateColumns={{ base: "1fr", md: "1fr 1fr" }}
                    gap={6}
                  >
                    <FormControl isInvalid={!!errors.paymentTerms}>
                      <FormLabel fontWeight="medium">Payment Terms</FormLabel>
                      <Input
                        name="paymentTerms"
                        value={formData.paymentTerms}
                        onChange={handleChange}
                        border="1px"
                        borderColor="gray.300"
                        _focus={{ borderColor: "blue" }}
                      />
                      {errors.paymentTerms && (
                        <FormErrorMessage>
                          {errors.paymentTerms}
                        </FormErrorMessage>
                      )}
                    </FormControl>
                    {role === "Influencer" ? (
                      <FormControl isInvalid={!!errors.CreatorPayout}>
                        <FormLabel fontWeight="medium">Total Amount</FormLabel>
                        <Input
                          name="CreatorPayout"
                          type="number"
                          value={formData.CreatorPayout}
                          onChange={handleChange}
                          border="1px"
                          borderColor="gray.300"
                          _focus={{ borderColor: "blue" }}
                        />
                        {errors.CreatorPayout && (
                          <FormErrorMessage>
                            {errors.CreatorPayout}
                          </FormErrorMessage>
                        )}
                      </FormControl>
                    ) : (
                      <FormControl isInvalid={!!errors.totalAmount}>
                        <FormLabel fontWeight="medium">Total Amount</FormLabel>
                        <Input
                          name="totalAmount"
                          type="number"
                          value={formData.totalAmount}
                          onChange={handleChange}
                          border="1px"
                          borderColor="gray.300"
                          _focus={{ borderColor: "blue" }}
                        />
                        {errors.totalAmount && (
                          <FormErrorMessage>
                            {errors.totalAmount}
                          </FormErrorMessage>
                        )}
                      </FormControl>
                    )}
                  </Grid>
                </Box>

                <Box mb={6}>
                  <FormControl isInvalid={!!errors.link}>
                    <FormLabel fontWeight="medium">Live Links</FormLabel>
                    <Input
                      name="link"
                      type="url"
                      value={formData.link}
                      onChange={handleChange}
                      border="1px"
                      borderColor="gray.300"
                      _focus={{ borderColor: "blue" }}
                    />
                    {errors.link && (
                      <FormErrorMessage>{errors.link}</FormErrorMessage>
                    )}
                  </FormControl>
                </Box>

                {role === "Influencer" && (
                  <>
                    <Box mb={4}>
                      <FormLabel fontWeight="500" fontSize="lg">
                        Payment Information
                      </FormLabel>
                    </Box>

                    <Box mb={6}>
                      <FormControl isInvalid={!!errors.payeesName}>
                        <FormLabel fontWeight="medium">Payee's Name</FormLabel>
                        <Input
                          name="payeesName"
                          value={formData.payeesName}
                          onChange={handleChange}
                          border="1px"
                          borderColor="gray.300"
                          _focus={{ borderColor: "blue" }}
                        />
                        {errors.payeesName && (
                          <FormErrorMessage>
                            {errors.payeesName}
                          </FormErrorMessage>
                        )}
                      </FormControl>
                    </Box>

                    <Box mb={4}>
                      <FormLabel fontWeight="medium">
                        Bank Information
                      </FormLabel>
                      <Grid
                        templateColumns={{ base: "1fr", md: "1fr 1fr 1fr" }}
                        gap={4}
                      >
                        <FormControl isInvalid={!!errors.bankName}>
                          <FormLabel fontSize="sm">Bank Name</FormLabel>
                          <Input
                            name="bankName"
                            value={formData.bankName}
                            onChange={handleChange}
                            border="1px"
                            borderColor="gray.300"
                            _focus={{ borderColor: "blue" }}
                          />
                          {errors.bankName && (
                            <FormErrorMessage>
                              {errors.bankName}
                            </FormErrorMessage>
                          )}
                        </FormControl>

                        <FormControl isInvalid={!!errors.accountNumber}>
                          <FormLabel fontSize="sm">Account Number</FormLabel>
                          <Input
                            name="accountNumber"
                            value={formData.accountNumber}
                            onChange={handleChange}
                            border="1px"
                            borderColor="gray.300"
                            _focus={{ borderColor: "blue" }}
                          />
                          {errors.accountNumber && (
                            <FormErrorMessage>
                              {errors.accountNumber}
                            </FormErrorMessage>
                          )}
                        </FormControl>

                        <FormControl isInvalid={!!errors.routingNumber}>
                          <FormLabel fontSize="sm">Routing Number</FormLabel>
                          <Input
                            name="routingNumber"
                            value={formData.routingNumber}
                            onChange={handleChange}
                            border="1px"
                            borderColor="gray.300"
                            _focus={{ borderColor: "blue" }}
                          />
                          {errors.routingNumber && (
                            <FormErrorMessage>
                              {errors.routingNumber}
                            </FormErrorMessage>
                          )}
                        </FormControl>
                      </Grid>
                    </Box>

                    <Box mb={6}>
                      <Grid
                        templateColumns={{ base: "1fr", md: "1fr 1fr" }}
                        gap={6}
                      >
                        <FormControl isInvalid={!!errors.swiftCode}>
                          <FormLabel fontSize="sm">
                            SWIFT Code (for international transfers)
                          </FormLabel>
                          <Input
                            name="swiftCode"
                            value={formData.swiftCode}
                            onChange={handleChange}
                            border="1px"
                            borderColor="gray.300"
                            _focus={{ borderColor: "blue" }}
                          />
                          {errors.swiftCode && (
                            <FormErrorMessage>
                              {errors.swiftCode}
                            </FormErrorMessage>
                          )}
                        </FormControl>
                        <FormControl isInvalid={!!errors.wire}>
                          <FormLabel fontSize="sm">Wires (Domestic)</FormLabel>
                          <Input
                            name="wire"
                            type="text"
                            value={formData.wire}
                            onChange={handleChange}
                            border="1px"
                            borderColor="gray.300"
                            _focus={{ borderColor: "blue" }}
                          />
                          {errors.wire && (
                            <FormErrorMessage>{errors.wire}</FormErrorMessage>
                          )}
                        </FormControl>{" "}
                      </Grid>
                    </Box>

                    <Box mb={6}>
                      <Grid
                        templateColumns={{ base: "1fr", md: "1fr 1fr" }}
                        gap={6}
                      >
                        <FormControl isInvalid={!!errors.paypalEmail}>
                          <FormLabel fontSize="sm">PayPal Email</FormLabel>
                          <Input
                            name="paypalEmail"
                            type="email"
                            value={formData.paypalEmail}
                            onChange={handleChange}
                            border="1px"
                            borderColor="gray.300"
                            _focus={{ borderColor: "blue" }}
                          />
                          {errors.paypalEmail && (
                            <FormErrorMessage>
                              {errors.paypalEmail}
                            </FormErrorMessage>
                          )}
                        </FormControl>

                        <FormControl isInvalid={!!errors.zelleEmail}>
                          <FormLabel fontSize="sm">Zelle Email</FormLabel>
                          <Input
                            name="zelleEmail"
                            type="email"
                            value={formData.zelleEmail}
                            onChange={handleChange}
                            border="1px"
                            borderColor="gray.300"
                            _focus={{ borderColor: "blue" }}
                          />
                          {errors.zelleEmail && (
                            <FormErrorMessage>
                              {errors.zelleEmail}
                            </FormErrorMessage>
                          )}
                        </FormControl>
                      </Grid>
                    </Box>
                  </>
                )}
              </form>
            </Box>
          </ModalBody>

          <ModalFooter>
            <Flex justifyContent="flex-end" gap={4}>
              <Button
                colorScheme="green"
                size="md"
                isLoading={isLoadingGeneratepdf}
                loadingText="Generating"
                onClick={handleSubmit}
              >
                Generate
              </Button>
              <Button
                colorScheme="blue"
                size="md"
                isLoading={isLoading}
                loadingText="Sending"
                onClick={handleSend}
              >
                Send
              </Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default InfluenceInVoiceModal;
